import React from 'react';

import {About, Copyright, Footer, Header, Skills, Work} from './container';
import { Navbar } from './components';
import "./App.scss"

const App = () => {
  return (
    <div className='app'>
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Footer />
      <Copyright />
      

    </div>


  )
}

export default App;